export default class {
    constructor (MaterialSubmissionResource, TokenService, lodash) {
        this.MaterialSubmissionResource = MaterialSubmissionResource;
        this.TokenService = TokenService;
        this.lodash = lodash;
    }

    generateFakeMaterialSubmission (material) {
        return this.MaterialSubmissionResource.save({ expand: 'material.chapters' }, {
            name: 'Test submission name',
            email: 'example@opus.ee',
            materialId: material.id,
            userId: this.TokenService.getUser().id
        }).$promise;
    }

    /**
     * Transforms the new unified material API structure into the
     * per-language format the frontend expects.
     *
     * New API returns: [{id, trainingId, languages: [...], chapters: [...]}]
     * Frontend expects: [{lang, isEnabled, chapters: [{name, content, hash, isVisible, section}]}]
     */
    transformMaterialsFromApi (materials) {
        if (!materials || !materials.length) {
            return [];
        }

        const firstMaterial = materials[0];

        // The unified material carries its languages in a separate collection. The legacy
        // `lang` column is still returned by the API (empty string), so it cannot be used
        // to tell the two formats apart. Materials that have not been migrated into the
        // unified structure yet have no language rows and are kept as they are, so their
        // content stays visible until the migration command has been run.
        if (!this.lodash.isArray(firstMaterial.languages) || !firstMaterial.languages.length) {
            return materials;
        }

        // New unified format — transform
        const languages = firstMaterial.languages || [];
        const chapters = firstMaterial.chapters || [];
        const settings = firstMaterial.settings;
        const result = [];

        this.lodash.forEach(languages, (languageRecord) => {
            const lang = languageRecord.lang;
            // an enabled language is visible to learners
            const isEnabled = languageRecord.isEnabled;
            const langChapters = [];

            this.lodash.forEach(chapters, (chapter) => {
                const i18n = this.lodash.find(
                    chapter.chapterI18ns || [],
                    { language: lang }
                );

                const chapterData = {
                    hash: chapter.hash,
                    name: i18n ? i18n.name : null,
                    content: i18n ? i18n.content : null,
                    isOpened: chapter.isOpened,
                    isVisible: i18n ? i18n.isVisible : true,
                    isTranslationConfirmed: i18n ? i18n.isTranslationConfirmed !== false : true,
                    translationConfirmedByName: i18n ? i18n.translationConfirmedByName : null,
                    translationConfirmedAt: i18n ? i18n.translationConfirmedAt : null,
                    // the backend decides whether the source has changed after the review
                    isTranslationOutdated: (chapter.outdatedTranslationLanguages || []).indexOf(lang) !== -1,
                    // only these translations can go out of date when the source content changes
                    isTranslationSourceTracked:
                        (chapter.sourceTrackedTranslationLanguages || []).indexOf(lang) !== -1,
                    sequence: chapter.sequence
                };

                if (chapter.section) {
                    const sectionI18n = this.lodash.find(
                        chapter.section.sectionI18ns || [],
                        { language: lang }
                    );
                    chapterData.section = {
                        id: chapter.section.id,
                        uniqueKey: chapter.section.id,
                        name: sectionI18n
                            ? sectionI18n.name
                            : chapter.section.name
                    };
                }

                langChapters.push(chapterData);
            });

            result.push({
                trainingId: firstMaterial.trainingId,
                lang,
                isEnabled,
                settings,
                chapters: langChapters
            });
        });

        return result;
    }

    /**
     * Orders the materials by the given languages. The API returns the languages of a
     * material alphabetically, while the editor keeps its models in the language order of
     * the company, and the two are matched by their position.
     */
    sortMaterialsByLanguages (materials, languages) {
        if (!languages || !languages.length) {
            return materials;
        }

        const ordered = [];

        this.lodash.forEach(languages, (lang) => {
            const material = this.lodash.find(materials, { lang });

            if (material) {
                ordered.push(material);
            }
        });

        this.lodash.forEach(materials, (material) => {
            if (ordered.indexOf(material) === -1) {
                ordered.push(material);
            }
        });

        return ordered;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/material/index.js